/* tslint:disable */
/* eslint-disable */
/**
 * Nightingale API
 *  ### Welcome to the Nightingale API !   To use the Nightingale API, you will need a `access_token` from **Bridgetech Support**  ## How to use swagger documentation   Click `Authorize` and paste your  `access_token` as `bearerAuth`  ## Design Notes 1. For non-mandatory fields, the API will allow you to submit `null` *or* omit fields entirely. 2. All query parameters are optional. Pagination fields default as follows: * page = 1 * limit = 20
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteSubscriptionNotificationRequest
 */
export interface DeleteSubscriptionNotificationRequest {
    /**
     * 
     * @type {string}
     * @memberof DeleteSubscriptionNotificationRequest
     */
    endpoint: string;
}

/**
 * Check if a given object implements the DeleteSubscriptionNotificationRequest interface.
 */
export function instanceOfDeleteSubscriptionNotificationRequest(value: object): value is DeleteSubscriptionNotificationRequest {
    if (!('endpoint' in value) || value['endpoint'] === undefined) return false;
    return true;
}

export function DeleteSubscriptionNotificationRequestFromJSON(json: any): DeleteSubscriptionNotificationRequest {
    return DeleteSubscriptionNotificationRequestFromJSONTyped(json, false);
}

export function DeleteSubscriptionNotificationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteSubscriptionNotificationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'endpoint': json['endpoint'],
    };
}

export function DeleteSubscriptionNotificationRequestToJSON(json: any): DeleteSubscriptionNotificationRequest {
    return DeleteSubscriptionNotificationRequestToJSONTyped(json, false);
}

export function DeleteSubscriptionNotificationRequestToJSONTyped(value?: DeleteSubscriptionNotificationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'endpoint': value['endpoint'],
    };
}

